<template>
  <div id="xps-server">
    <el-container id="components-layout-demo-fixed">
      <el-header :style="{ position: 'fixed', zIndex: 1, width: '100%', backgroundColor:'#fff',boxShadow:'0 1px 10px rgb(0 0 0 / 8%)'}" v-if="show">
        <span @click.stop="goIndexPage" class="logo" title="XPS"></span>
        <el-menu :default-active="activeMenu" mode="horizontal" background-color="#fff" text-color="#9d9da8" @select="handleSelect" :style="{ lineHeight: '64px',display:'inline-block' }">
          <el-menu-item index="/fileUpload">
            <span class="iconfont icon-file-upload menu-item-icon"></span>
            <strong>文件上传</strong>
          </el-menu-item>
          <el-menu-item index="/fileManage">
            <span class="iconfont icon-wenjianjiawenjianguanli menu-item-icon"></span>
            <strong>文件管理</strong>
          </el-menu-item>
          <el-menu-item index="/myFiles">
            <span class="iconfont icon-grinning-face menu-item-icon"></span>
            <strong>我的文件</strong>
          </el-menu-item>
          <el-menu-item index="/staticPage">
            <span class="iconfont icon-page menu-item-icon"></span>
            <strong>静态页面</strong>
          </el-menu-item>
          <el-menu-item index="/xpsCdn">
            <span class="iconfont icon-CDN menu-item-icon"></span>
            <strong>XPSCDN</strong>
          </el-menu-item>
          <!-- <el-menu-item index="/appUpload">
            <span class="iconfont icon-APPBuilder-DMB menu-item-icon"></span>
            <strong>APP版本</strong>
          </el-menu-item> -->
        </el-menu>
        <div class="right-menu">
          <el-dropdown v-show="avatar&&name" class="avatar-container" trigger="click">
            <div class="avatar-wrapper">
              <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar" alt="error">
              <span class="avatar-name">{{name}}
                <span>{{'('+userInfo.dept+')'}}</span>
              </span>
              <em class="el-icon-caret-bottom" :style="{color:'#9d9da8',}" />
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown">
              <a href="javascript:;" @click="showCdnModal">
                <el-dropdown-item><em class="el-icon-refresh"></em>处理CDN</el-dropdown-item>
              </a>
              <a href="javascript:;" @click="showUserModal">
                <el-dropdown-item><em class="el-icon-user"></em>用户信息</el-dropdown-item>
              </a>
              <a href="javascript:;" @click="showHelpModal">
                <el-dropdown-item><em class="el-icon-help"></em>帮助文档</el-dropdown-item>
              </a>
              <a href="javascript:;" @click="showOperationModal">
                <el-dropdown-item><em class="el-icon-s-operation"></em>操作日志</el-dropdown-item>
              </a>
              <a href="javascript:;" @click="showQRCodeModal()">
                <el-dropdown-item><em class="iconfont icon-erweima1" style="font-size:13px;"></em>二维码生成</el-dropdown-item>
              </a>
              <a href="javascript:;" @click="showPlatformAppy">
                <el-dropdown-item><em class="el-icon-postcard"></em>平台准入申请</el-dropdown-item>
              </a>
              <a href="javascript:;" v-if="userInfo.isAdmin" @click="showSystemSetting">
                <el-dropdown-item><em class="el-icon-set-up"></em>系统设置</el-dropdown-item>
              </a>
              <el-dropdown-item divided @click.native="signOut">
                <span style="display:block;"><em class="el-icon-switch-button"></em>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main :style="{ padding: '0px',height:'100%',...style}">
        <router-view @header="isHeader" @showQRCode="showQRCodeModal" />
      </el-main>
    </el-container>

    <!-- 对话框 -->
    <el-dialog :top="dialog.top" :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" :before-close="destroyComponent">
      <component :is="dialog.component" @close="destroyComponent" :url="url" />
    </el-dialog>

  </div>
</template>
<script>
import { dialogMixin } from "@/common/mixins/";
import cdnModal from '@/views/menuDialog/cdnModal/index.vue';
import userInfoModal from '@/views/menuDialog/userInfo.vue';
import helpDocument from '@/views/menuDialog/helpDocument.vue';
import generateQRCode from '@/views/menuDialog/generateQRCode.vue';
import operationLogs from '@/views/menuDialog/operationLogs.vue';
import operationAllLogs from '@/views/menuDialog/operationAllLogs.vue';
import systemSetting from '@/views/menuDialog/systemSetting/index.vue';
import platformApply from '@/views/menuDialog/platform/index.vue';
import { mapGetters } from 'vuex';

export default {
  mixins: [dialogMixin],
  data () {
    return {
      selectedKeys: [],
      header: '',
      style: { marginTop: '64px' },
      interval: null,
      activeMenu: '',
      show: true,
      errorPage: ['/404', '/401', '/htmlPage'],
      timer: null,
      url: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'avatar', 'name'])
  },
  mounted () {
    if (this.header != '') {
      this.style = {};
    }
    // 默认选中路由中的当前活跃菜单
    let path = this.$route.path.split('/');
    this.activeMenu = `/${path[1]}`;
  },
  watch: {
    header (val) {
      if (val != '') {
        this.style = {};
      }
    },
    // 监听路由--激活菜单
    $route: {
      handler: function (val, oldVal) {
        let path = this.$route.path.split('/');
        this.activeMenu = `/${path[1]}`;
      }
    },
    // 如果是错误页 去掉头部
    activeMenu (val) {
      this.show = !this.errorPage.includes(val);
    },
    // 监听vuex userInfo的数据改变  修改/新增水印
    userInfo: {
      deep: true,
      handler (val) {
        // 加载水印
        this.loadingWatermark(`${val.realName} ${val.mobile}`);
      }
    }
  },
  methods: {
    // 加载medusa水印
    loadingWatermark (name) {
      if (window.medusaWatermark) {
        window.medusaWatermark(name);
      } else {
        // 如果水印js还没有加载 开启水印加载定时器
        this.timer = setInterval(() => {
          if (window.medusaWatermark) {
            window.medusaWatermark(name);
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 100)
        // 如果没有开启或者水印js加载时间超过5s 关闭水印定时器
        setTimeout(() => {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 5000)
      }
    },
    goIndexPage () {
      this.$router.push('/');
    },
    isHeader (val) {
      this.header = val;
    },
    signOut () {
      window.$globalOidc.signoutRedirect();
    },
    // 显示平台准入申请对话框
    showPlatformAppy () {
      this.setDialog(true, "平台准入", platformApply, "1200px", "5vh");
    },
    // 显示系统设置对话框
    showSystemSetting () {
      this.setDialog(true, "系统设置", systemSetting, "1200px", "5vh");
    },
    // 显示操作日志对话框
    showOperationModal () {
      if (this.userInfo.isAdmin) {
        this.setDialog(true, "操作日志（管理员）", operationAllLogs, "1200px", "5vh");
      } else {
        this.setDialog(true, "操作日志", operationLogs, "800px", "5vh");
      }
    },
    // 显示用户信息对话框
    showUserModal () {
      this.setDialog(true, "用户信息", userInfoModal, "800px", "15vh");
    },
    // 显示Cdn信息对话框
    showCdnModal () {
      this.setDialog(true, "CDN处理", cdnModal, "800px", "5vh");
    },
    // 显示二维码生成对话框
    showQRCodeModal (url = '') {
      if (url) {
        this.url = url;
      }
      this.setDialog(true, "二维码生成", generateQRCode, "800px", "15vh");
    },
    // 显示帮助文档对话框
    showHelpModal () {
      this.setDialog(true, "帮助文档", helpDocument, "800px", "15vh");
    },
    // 导航菜单改变触发事件
    handleSelect (key, keyPath) {
      this.$router.push(key)
    },
    // 销毁动态组件
    destroyComponent () {
      this.setDialog(false, "", null, "1100px", "1vh");
    }
  }
}

</script>
<style lang="scss">
#xps-server {
  height: 100%;
}
#components-layout-demo-fixed {
  height: 100%;
}
#components-layout-demo-fixed .logo {
  display: inline-block;
  margin-left: -20px;
  width: 110px;
  height: 100%;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  border-right: 2px solid #efefef;
  background: url("https://front-xps-cdn.xsyx.xyz/2021/07/19/537882149.png");
  line-height: 64px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px;
  cursor: pointer;
}
.menu-item-icon {
  margin-right: 3px;
}
.right-menu {
  float: right;
  height: 100%;
  line-height: 50px;

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .avatar-container {
    height: 100%;
    .avatar-wrapper {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      // height: ;
      .avatar-name {
        padding: 0 10px 0 15px;
        font-weight: 700;
        color: #606266;
        > span {
          color: #9d9da8;
        }
      }
      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        font-size: 12px;
      }
    }
  }
}
</style>
